/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssetUploadedBody
 */
export interface CreateAssetUploadedBody {
    /**
     * 
     * @type {string}
     * @memberof CreateAssetUploadedBody
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetUploadedBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetUploadedBody
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateAssetUploadedBody interface.
 */
export function instanceOfCreateAssetUploadedBody(value: object): value is CreateAssetUploadedBody {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function CreateAssetUploadedBodyFromJSON(json: any): CreateAssetUploadedBody {
    return CreateAssetUploadedBodyFromJSONTyped(json, false);
}

export function CreateAssetUploadedBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssetUploadedBody {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateAssetUploadedBodyToJSON(json: any): CreateAssetUploadedBody {
    return CreateAssetUploadedBodyToJSONTyped(json, false);
}

export function CreateAssetUploadedBodyToJSONTyped(value?: CreateAssetUploadedBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'name': value['name'],
        'description': value['description'],
    };
}

